module.exports = {"label":{"calls":"Call list","resources":"System status"}}